var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 27",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.806a12.036 12.036 0 0 1-1.2 5.277 11.643 11.643 0 0 1-4.177 4.763 10.998 10.998 0 0 1-5.956 1.765 10.81 10.81 0 0 1-5.067-1.25L1 26l2.533-7.917a12.036 12.036 0 0 1-1.2-5.277c.001-2.192.588-4.34 1.695-6.205A11.518 11.518 0 0 1 8.6 2.25 10.81 10.81 0 0 1 13.667 1h.666c2.78.16 5.404 1.382 7.373 3.432 1.968 2.05 3.14 4.784 3.294 7.68v.694Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgChat;